import axios from "axios";
import React, { useEffect, useState } from "react";
import Catagory from "../components/homepage/Catagory";
import Hero from "../components/homepage/Hero";
import HomeProduct from "../components/homepage/HomeProduct";

const Home = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const faceData = () => {
      try {
        axios.get(`https://mcpedls.com/home`).then((res) => {
          setData(res.data);
        });
      } catch (error) {
        console.log(error);
      }
    };
    faceData();
  }, []);

  return (
    <>
      {data.length && (
        <>
          <Hero data={data} />
          <Catagory data={data} />
          <HomeProduct data={data}/>
        </>
      )}
    </>
  );
};

export default Home;
